import { render, staticRenderFns } from "./InternalManagementTable.vue?vue&type=template&id=04e32844"
import script from "./InternalManagementTable.vue?vue&type=script&lang=js"
export * from "./InternalManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports